export default {
  success: '#4CAF50',
  warning: '#FF9800',
  error: '#F44336',
  info: '#4CAF50',
  default: '#000'
};
